__turbopack_context__.v({
  "container": "style-module-scss-module__SwyjEq__container",
});
